export default __webpack_public_path__ + "static/media/element_32.58b36f7e.avif";